export function getEnvironmentFromApiKey(apiKey: string) {
  return apiKey.startsWith('pk_live') ? 'production' : 'sandbox';
}
